import { SxProps, Theme } from '@mui/material';

export const stylesSubscribeAdditionnalInformationFormGridContainer: SxProps<Theme> = {
  height: '100%',
};

export const stylesSubscribeAdditionnalInformationGridItem: SxProps<Theme> = {
  height: '100%',
};

export const stylesSubscribeAdditionnalInformationCard: SxProps<Theme> = {
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
};

export const stylesSubscribeAdditionnalInformationCardSubheader: SxProps<Theme> = {
  fontWeight: 'fontWeightRegular',
  mt: 2,
};

export const stylesSubscribeAdditionnalInformationCardContent: SxProps<Theme> = {
  flex: 1,
  overflow: 'auto',
};

export const stylesSubscribeAdditionnalInformationFormSubtitle: SxProps<Theme> = {
  fontWeight: 'fontWeightRegular',
  color: 'primary.main',
  pb: 1,
};

export const stylesAutoCompleteSingleSelect = {
  '&.MuiAutocomplete-root .MuiAutocomplete-inputRoot': {
    padding: '0px !important',
  },
};
